type Listener = () => void;

const listeners = new Set<Listener>();

export function onDatosCambiados(fn: Listener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

export function emitirDatosCambiados(): void {
  listeners.forEach((fn) => {
    try {
      fn();
    } catch (e) {
      console.error('Listener falló:', e);
    }
  });
}
